import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../api-service/api.service';
import { BackupSubscription } from '@sk-models';
import { saveAs } from 'file-saver';

@Component({
  selector: 'sk-folder-size-summary-modal',
  templateUrl: './folder-size-summary-modal.component.html',
  styleUrls: ['./folder-size-summary-modal.component.scss']
})
export class FolderSizeSummaryModalComponent {
  subscription: BackupSubscription;
  isLoading: boolean;
  errorMessage: string;

  constructor(
      @Inject(MAT_DIALOG_DATA) data: { subscription: BackupSubscription },
      public dialogRef: MatDialogRef<FolderSizeSummaryModalComponent>,
      private apiService: ApiService) {
    this.subscription = data?.subscription;
  }

  onExportFolderSizeSummary(): void {
    this.errorMessage = null;
    this.isLoading = true;
    this.apiService.exportFolderSizeSummary(this.subscription.backupServiceId, this.subscription.resourceKey)
      .subscribe({
        next: (fileData) => this.downloadFile(fileData),
        complete: () => {
          this.isLoading = false;
          this.dialogRef.close();
        },
        error: (e) => this.errorMessage = `Request failed! Details: ${JSON.stringify(e)}`
      })
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  /* eslint-disable @typescript-eslint/explicit-module-boundary-types */
  downloadFile(fileData: any): void {
    if (fileData) {
      saveAs(fileData, `${this.subscription.subscriptionType}-FolderSizeSummary-${this.subscription.id}.xlsx`);
    }
  }
}
